// apps/web/src/components/landing-v2/PricingCards.tsx
import { Link } from 'react-router-dom'
import { Check } from 'lucide-react'

const SEEKER = [
  'Daily pull a card',
  'Moon calendar',
  "Today's astrological weather",
  'Copy a reading link',
]

const COSMIC = [
  'Everything in Seeker',
  'Full deck library — every deck across our creators',
  'Soul journal + reading threads',
  '3- and 5-card spreads',
  'Natal chart',
  'Audio rituals as they ship',
  'Live ceremonies with Sarah and Adrienne',
]

/** Side-by-side pricing cards. Free Seeker tier vs $9.99/mo Cosmic
 *  with a 7-day trial. Cosmic card gets a gold accent + violet tint. */
export function PricingCards() {
  return (
    <section id="pricing" className="mx-auto max-w-[1100px] px-5 py-20 md:px-8">
      <header className="reveal text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Pricing</p>
        <h2 className="mt-3 font-display text-4xl italic font-light md:text-5xl">Two ways in</h2>
      </header>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <article className="reveal rounded-xl border border-hairline bg-cosmic-card p-8 shadow-card">
          <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Seeker</p>
          <p className="mt-2 font-display text-5xl font-light">Free</p>
          <p className="mt-2 text-sm text-text-secondary">A daily pull. The basics, on us.</p>
          <ul className="mt-6 space-y-2 text-sm text-text-secondary">
            {SEEKER.map((f) => (
              <li key={f} className="flex gap-2">
                <Check size={16} strokeWidth={1.75} className="mt-0.5 shrink-0 text-text-muted" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/sign-up"
            className="mt-8 inline-block rounded-md border border-hairline-strong px-5 py-2.5 text-sm text-text-primary hover:border-white/[0.16] transition-colors"
          >
            Start free
          </Link>
        </article>

        <article className="reveal rounded-xl border border-gold/30 bg-gradient-to-br from-cosmic-card via-cosmic-card to-deep-purple/40 p-8 shadow-card shadow-glow-gold">
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Cosmic</p>
          <p className="mt-2">
            <span className="font-display text-5xl font-light text-gold">$9.99</span>
            <span className="text-sm text-text-muted"> / month</span>
          </p>
          <p className="mt-2 text-sm text-text-secondary">7 days free. Cancel anytime.</p>
          <ul className="mt-6 space-y-2 text-sm text-text-secondary">
            {COSMIC.map((f) => (
              <li key={f} className="flex gap-2">
                <Check size={16} strokeWidth={1.75} className="mt-0.5 shrink-0 text-gold" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/sign-up"
            className="mt-8 inline-block rounded-md bg-gold px-5 py-2.5 text-sm font-medium text-cosmic-black hover:bg-gold-light transition-colors"
          >
            Begin a reading
          </Link>
        </article>
      </div>
    </section>
  )
}
